/**
 * LoyaltyLion Points Display for PLP and Quickview
 * Ensures loyalty points are populated on collection pages
 */
(function() {
  'use strict';

  // Configuration
  var MAX_RETRIES = 10;
  var RETRY_DELAYS = [500, 1000, 1500, 2000, 3000, 4000, 5000, 7000, 10000, 15000];
  var retryCount = 0;

  /**
   * Check if LoyaltyLion SDK is ready
   */
  function isLoyaltyLionReady() {
    return typeof loyaltylion !== 'undefined' &&
           loyaltylion.ui &&
           typeof loyaltylion.ui.refresh === 'function';
  }

  /**
   * Check if points are populated in the DOM
   */
  function arePointsPopulated() {
    var pointsElements = document.querySelectorAll('[data-lion-points-for-product-id]');
    if (pointsElements.length === 0) return true; // No elements to populate

    // Check if at least some elements have content
    var populatedCount = 0;
    for (var i = 0; i < pointsElements.length; i++) {
      if (pointsElements[i].textContent.trim() !== '') {
        populatedCount++;
      }
    }

    // Consider populated if at least 50% have values (SDK might still be processing)
    return populatedCount >= (pointsElements.length * 0.5);
  }

  /**
   * Trigger LoyaltyLion UI refresh
   */
  function refreshLoyaltyLion() {
    if (isLoyaltyLionReady()) {
      try {
        loyaltylion.ui.refresh();
        return true;
      } catch (e) {
        console.warn('[LoyaltyLion PLP] Error refreshing UI:', e);
        return false;
      }
    }
    return false;
  }

  /**
   * Retry logic with increasing delays
   */
  function attemptRefresh() {
    if (retryCount >= MAX_RETRIES) {
      console.warn('[LoyaltyLion PLP] Max retries reached, points may not display');
      return;
    }

    // Check if already populated
    if (arePointsPopulated()) {
      console.log('[LoyaltyLion PLP] Points already populated');
      return;
    }

    // Try to refresh
    if (refreshLoyaltyLion()) {
      // Wait a bit and check if populated
      setTimeout(function() {
        if (!arePointsPopulated() && retryCount < MAX_RETRIES) {
          retryCount++;
          var delay = RETRY_DELAYS[retryCount - 1] || RETRY_DELAYS[RETRY_DELAYS.length - 1];
          setTimeout(attemptRefresh, delay);
        }
      }, 500);
    } else {
      // SDK not ready, retry after delay
      retryCount++;
      var delay = RETRY_DELAYS[retryCount - 1] || RETRY_DELAYS[RETRY_DELAYS.length - 1];
      setTimeout(attemptRefresh, delay);
    }
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    // Start refresh attempts
    attemptRefresh();

    // Also observe for dynamically loaded content (quickview, infinite scroll, etc.)
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function(mutations) {
        var hasNewPointsElements = false;
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.querySelector && node.querySelector('[data-lion-points-for-product-id]')) {
                hasNewPointsElements = true;
              }
              if (node.hasAttribute && node.hasAttribute('data-lion-points-for-product-id')) {
                hasNewPointsElements = true;
              }
            }
          });
        });

        if (hasNewPointsElements) {
          // New loyalty points elements added, refresh SDK
          setTimeout(function() {
            refreshLoyaltyLion();
          }, 100);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also listen for LoyaltyLion's ready event if available
  if (typeof loyaltylion !== 'undefined' && loyaltylion.on) {
    loyaltylion.on('ready', function() {
      attemptRefresh();
    });
  }
})();
